module.exports = __webpack_public_path__ + "img/a.86fa02bf.png";